import { ref } from 'vue';

// Estado global para la imagen de fondo del show
const showImage = ref(null); // Imagen del show actual
const previousShowImage = ref(null); // Imagen del show anterior para transición

export function useBackgroundEffect() {
  const setShowImage = (imageUrl) => {
    if (imageUrl !== showImage.value) {
      previousShowImage.value = showImage.value;
      showImage.value = imageUrl;
    }
  };

  const clearShowImage = () => {
    previousShowImage.value = showImage.value;
    showImage.value = null;
  };

  return {
    showImage,
    previousShowImage,
    setShowImage,
    clearShowImage,
  };
}
